import React, { lazy } from 'react';
import { Button } from './Button';
import { ShieldCheck, Heart, Sparkles, Gift } from 'lucide-react';
import { UrgencyBanner } from './UrgencyBanner';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-70">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-71">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-sage-light/20 blur-3xl" data-id="element-72" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-terracotta-light/10 blur-3xl" data-id="element-73" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-75">
          {/* Left Column: Copy */}
          <div className="max-w-2xl" data-id="element-76">
            <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-sage-light/30 text-sage-dark text-sm font-medium mb-6" data-id="element-77">
              <Sparkles className="w-4 h-4" data-id="element-78" />
              <span data-id="element-79">Para perros y gatos</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 leading-tight mb-6" data-id="element-80">
              Duplica los años de vida de tu{' '}
              <span className="text-sage-dark italic" data-id="element-81">mejor amigo</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-82">
              El Método Maestro de Bio-Nutrición y Convivencia. Descubre los
              secretos científicamente probados para una vida más larga, sana y
              feliz junto a tu mascota.
            </p>

            <UrgencyBanner data-id="element-83" />

            <p className="text-sm md:text-base font-medium text-sage-dark mb-6 flex items-center" data-id="element-84">
              <Sparkles className="w-4 h-4 mr-2 text-terracotta" data-id="element-85" />
              <span data-id="element-86">
                <span className="font-bold uppercase tracking-wider text-terracotta" data-id="element-87">
                  Precio de lanzamiento:
                </span>{' '}
                solo <span className="font-bold" data-id="element-88">$17 USD</span> por tiempo
                limitado.
              </span>
            </p>

            <div className="relative inline-block mb-2" data-id="element-89">
              <Button size="lg" withArrow href="https://pay.hotmart.com/I106053932U" data-id="element-90">
                Lo Necesito Ya! · $17 USD
              </Button>

              {/* Stamp: strikethrough original price + discount badge */}
              <div className="absolute -top-5 -right-3 sm:-right-6 transform rotate-12 pointer-events-none" data-id="element-91">
                <div className="bg-white border-2 border-terracotta rounded-full px-3 py-1.5 shadow-lg flex flex-col items-center leading-none" data-id="element-92">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-terracotta" data-id="element-93">
                    -91% OFF
                  </span>
                  <span className="text-[11px] text-gray-500 line-through decoration-red-400 decoration-2 font-semibold" data-id="element-94">
                    $197 USD
                  </span>
                </div>
              </div>
            </div>

            <p className="text-xs sm:text-sm text-gray-600 mb-8 flex items-center" data-id="element-95">
              <Gift className="w-4 h-4 mr-1.5 text-terracotta shrink-0" data-id="element-96" />
              Incluye{' '}
              <span className="font-bold text-terracotta mx-1" data-id="element-97">
                5 bonos exclusivos
              </span>{' '}
              GRATIS
            </p>

            <div className="flex items-center space-x-6 text-sm text-gray-500" data-id="element-98">
              <div className="flex items-center" data-id="element-99">
                <ShieldCheck className="w-5 h-5 text-sage mr-2" data-id="element-100" />
                <span data-id="element-101">Garantía 30 días</span>
              </div>
              <div className="flex items-center" data-id="element-102">
                <Heart className="w-5 h-5 text-terracotta mr-2" data-id="element-103" />
                <span data-id="element-104">Acceso Inmediato</span>
              </div>
            </div>
          </div>

          {/* Right Column: 3D Mockup */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-105">
            <div className="relative aspect-[4/5] w-full" data-id="element-106">
              {/* Image Frame */}
              <div className="absolute inset-0 rounded-3xl shadow-2xl transform rotate-3 transition-transform hover:rotate-0 duration-500 overflow-hidden border-8 border-white/20" data-id="element-107">
                <img src="https://cdn.magicpatterns.com/uploads/auiVuZTR3yfBjbqewji9DT/Bono_3.jpg" alt="Perro y gato descansando juntos" width={1024} height={1024} loading="eager" fetchPriority="high" decoding="async" className="w-full h-full object-cover" data-id="element-108" />
              </div>

              {/* Decorative floating elements */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-terracotta rounded-2xl shadow-lg transform -rotate-12 flex items-center justify-center p-4" data-id="element-109">
                <span className="text-white font-bold text-center text-sm leading-tight" data-id="element-110">
                  100%
                  <br data-id="element-111" />
                  Digital
                </span>
              </div>
              <div className="absolute -top-6 -right-6 w-20 h-20 bg-cream-dark rounded-full shadow-lg flex items-center justify-center" data-id="element-112">
                <Sparkles className="w-8 h-8 text-sage-dark" data-id="element-113" />
              </div>
            </div>

            {/* Testimonials below image */}
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-114">
              {[{
              text: 'En 2 semanas, Toby volvió a saltar al sofá como cachorro. ¡No lo podía creer!',
              name: 'María G.',
              pet: 'mamá de Toby',
              img: 'https://i.pravatar.cc/100?img=47'
            }, {
              text: 'Mi gata Luna recuperó el brillo en su pelo y la energía. Vale cada centavo.',
              name: 'Andrés P.',
              pet: 'papá de Luna',
              img: 'https://i.pravatar.cc/100?img=12'
            }].map((t, i) => <div key={i} className="bg-white rounded-2xl p-4 shadow-soft border border-sage-light/40" data-id="element-115">
                  <div className="flex text-terracotta mb-2" data-id="element-116">
                    {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-117">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-118" />
                      </svg>)}
                  </div>
                  <p className="text-gray-700 text-sm leading-snug mb-3 italic" data-id="element-119">
                    "{t.text}"
                  </p>
                  <div className="flex items-center" data-id="element-120">
                    <img src={t.img} alt={t.name} width={32} height={32} loading="lazy" decoding="async" className="w-8 h-8 rounded-full mr-2 object-cover" data-id="element-121" />
                    <div data-id="element-122">
                      <p className="text-xs font-bold text-gray-900 leading-tight" data-id="element-123">
                        {t.name}
                      </p>
                      <p className="text-[10px] text-gray-500" data-id="element-124">{t.pet}</p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}